module.exports = __webpack_public_path__ + "static/media/25-15.8d8146dd.mp3";